import { StubPage } from '../StubPage'
export function Datasets() {
  return <StubPage title="Datasets" summary="Datasets are named containers for documents within a business. They support role-based membership (owner, reader, member) and can be shared with multiple services for cross-service file access." />
}
